import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    visitStartedAt: String,
    minVisitMinutes: { type: Number, default: 1 },
  };

  connect() {
    console.log("nps");
    if (this.isDismissed()) {
      this.element.remove();
      return;
    }

    this.checkVisitAge();
  }

  checkVisitAge() {
    if (!this.visitStartedAtValue) {
      this.show();
      return;
    }

    const startedAt = new Date(this.visitStartedAtValue);
    const minutesElapsed = (new Date() - startedAt) / 60000;

    if (minutesElapsed >= this.minVisitMinutesValue) {
      this.show();
    } else {
      const remainingMs = (this.minVisitMinutesValue - minutesElapsed) * 60000;
      this.timer = setTimeout(() => this.show(), remainingMs);
    }
  }

  show() {
    this.element.classList.remove("hidden");
  }

  dismiss() {
    localStorage.setItem("nps_survey_dismissed_at", new Date().toISOString());
    this.element.remove();
  }

  isDismissed() {
    const dismissedAt = localStorage.getItem("nps_survey_dismissed_at");
    if (!dismissedAt) return false;
    const daysSinceDismissal = (new Date() - new Date(dismissedAt)) / 86400000;
    return daysSinceDismissal < 30;
  }

  disconnect() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
